import axios from '@/server/request'
export default class api {
    /**
     * 时事热点
     * @param {*} params
     */
    static getRealTime(params) {
        return axios.post({
            url: '/Hotcenter/realTime',
            params
        })
    }

    /**
     * 最新政策
     * @param {*} params
     */
    static getPolicy(params) {
        return axios.get({
            url: '/Hotcenter/policy',
            params
        })
    }

    /**
     * 最新政策v2
     * @param {*} params
     */
    static getPolicyV2(params) {
        return axios.get({
            url: '/Policy/policyList',
            params
        })
    }

    /**
     * 最新政策详情
     * @param {*} params
     */
    static getPolicyDetail(params) {
        return axios.get({
            url: '/Policy/policyInfo',
            params
        })
    }

    /**
     * 热门房企
     * @param {*} params
     */
    static getHotHousinglist(params) {
        return axios.get({
            url: '/Hotcenter/hotFangqi',
            params
        })
    }

    /**
     * 热门城市
     * @param {*} params
     */
    static getHotCtiylist(params) {
        return axios.get({
            url: '/Hotcenter/hotCity',
            params
        })
    }

    /**
     * 设置关注城市
     * @param {*} params
     */
    static getAttention(params) {
        return axios.get({
            url: '/city/attention',
            params
        })
    }

    /**
     * 热门事件
     * @param {*} params
     */
    static getEventList(params) {
        return axios.get({
            url: '/Event/eventList',
            params
        })
    }

    /**
     * 解析搜索关键词中的城市
     * @param {*} params
     */
    static getHotKeyword(params) {
        return axios.get({
            url: '/Hotcenter/searchCityKeyWord',
            params
        })
    }
}
